import selectWebcast from './selectWebcast'
import {
  selectCommunications, selectTotalCommunications, selectCommunicationsIsLoading,
  selectSyndication, selectSyndicationLoading, selectSyndicationError
} from './selectCommunications'
import { selectActivity, selectActivityIsLoading, selectLatestActivities, selectLatestActivitiesIsLoading, selectTotalActivities, selectActivitiesDate } from './selectActivity'
import { selectReportId, selectInitGenReportInProgress, selectIsGeneratingReport, selectReportURL, selectReportCancelStatus, selectReportGenerationError } from './selectReports'
import { selectCalendlyAccountName, selectOwnerDataIsLoading } from './selectOwner'
import { selectFirstName, selectLastName, selectEmail } from './selectUser'
import { selectPreRegistrationsCount, selectViewersCount, selectAttendance, selectAverageMinutesViewed, selectEventDuration, selectViewerInteraction, selectDurationView, selectAudienceSummaryIsLoading, selectSources } from './selectAudienceSummary'
import { selectFeedbackCount, selectFeedbackData, selectAverageRating, selectFeedbackDataIsLoading, selectTotalFeedbackCount } from './selectFeedbackSummary'
import { selectQuestionsCount } from './selectQuestionsDetails'
import { selectAudienceChart, selectAudienceChartIsLoading } from './selectAudienceChart'
import { selectContentPerformanceChart } from './selectContentPerformanceChart'
import { selectSyndicationData, selectSyndicationDataIsLoading, selectApprovalInfo } from './selectSyndicationData'
import { selectLiveViewer } from './selectLiveViewers'
import { selectAudienceViewingChart } from './selectAudienceViewingChart'
import { selectOndemandViewers } from './selectOndemandViewers'
import { selectSubscriberGrowthChart, selectSubscriberGrowthChartIsLoading } from './selectSubscriberGrowthChart'
import {
  selectNurtureAnalytics,
  selectNurtureAnalyticsData,
  selectNurtureAnalyticsStats,
  selectNurtureAnalyticsLoading,
  selectNurtureAnalyticsError,
  selectNurtureAnalyticsUiState,
  selectNurtureAnalyticsDownloadInProgress,
  selectNurtureAnalyticsDownloadError
} from './selectNurtureAnalytics/selectNurtureAnalytics'
import { selectAudienceGrowthChart } from './selectAudienceGrowthChart'
import { selectSubscribers, selectSubscribersIsLoading, selectTotalSubscribers } from './selectSubscribers'
import { selectQuestionsListings, selectQuestionsListIsLoading } from './selectQuestionsListings'
import { selectDownloadCount, selectAttachments } from './selectAttachmentDetails'
import { selectVotesDetails } from './selectVotesDetails'
import { selectVotesListings, selectVotesListIsLoading, selectTotalVotesCount } from './selectVotesListings'
import { selectChannelFeatures, selectChannelFeaturesLoading, selectUpdateFeaturesLoading, selectUpdateFeaturesStatus, selectUpdateFeaturesError } from './selectChannelFeatures'
import { selectUpdateInProgress, selectChannelUpdateStatus } from './selectChannel';
import {
  selectEmailTemplatesList, selectEmailTemplate, selectCreateTemplateStatus, selectDeleteTemplateIsLoading,
  selectEmailTemplatesListIsLoading, selectUpdateTemplateStatus, selectCreateTemplateEmailId,
  selectEmailTemplatesListTotal, selectDeactivateTemplateIsLoading, selectActivateTemplateIsLoading,
  selectSendTemplateStatus, selectEmailPreviewTemplate, selectSendTemplateResponse, selectEmailTypesList, selectBasicEmailTemplate
} from './selectEmail'
import {
  selectUserEmailPreferences, selectUserEmailPreferencesLoading, selectUserRoles,
  selectUserRolesLoading, selectUpdatedUserRolesLoading, selectResetUserPasswordLoading,
  selectUserProfileDetails, selectUpdateEmailPreferencesLoading, selectUserProfileDetailsLoading,
  selectUserProfileDetailsUpdateInProgress, selectUserProfileDetailsUpdatedData, selectUpdateEmailPreferencesAccordionFlag, selectUserEmailPreferencesAccordionFlag
} from './selectUserDetails'
import {
  selectVirtualEventsReportId, selectVirtualEventsReportInProgress, selectVirtualEventsReportIsGenerating,
  selectVirtualEventsReportURL, selectVirtualEventsReportCancelStatus, selectVirtualEventsReportGenerationError
} from './selectVirtualEventsReport'

export default {
  selectWebcast,
  selectCommunications,
  selectTotalCommunications,
  selectCommunicationsIsLoading,
  selectActivity,
  selectActivityIsLoading,
  selectReportId,
  selectInitGenReportInProgress,
  selectIsGeneratingReport,
  selectReportURL,
  selectReportCancelStatus,
  selectSyndication,
  selectSyndicationLoading,
  selectLatestActivities,
  selectLatestActivitiesIsLoading,
  selectTotalActivities,
  selectActivitiesDate,
  selectCalendlyAccountName,
  selectOwnerDataIsLoading,
  selectFirstName,
  selectLastName,
  selectEmail,
  selectPreRegistrationsCount,
  selectViewersCount,
  selectQuestionsCount,
  selectFeedbackCount,
  selectAttendance,
  selectAverageMinutesViewed,
  selectEventDuration,
  selectViewerInteraction,
  selectDurationView,
  selectAudienceSummaryIsLoading,
  selectAudienceChart,
  selectAudienceChartIsLoading,
  selectReportGenerationError,
  selectSubscriberGrowthChart,
  selectSubscriberGrowthChartIsLoading,
  selectLiveViewer,
  selectAudienceViewingChart,
  selectOndemandViewers,
  selectAudienceGrowthChart,
  selectSyndicationData,
  selectSyndicationDataIsLoading,
  selectSyndicationError,
  selectApprovalInfo,
  selectSources,
  selectSubscribers,
  selectSubscribersIsLoading,
  selectTotalSubscribers,
  selectContentPerformanceChart,
  selectQuestionsListings,
  selectQuestionsListIsLoading,
  selectDownloadCount,
  selectAttachments,
  selectVotesDetails,
  selectVotesListings,
  selectVotesListIsLoading,
  selectFeedbackData,
  selectAverageRating,
  selectFeedbackDataIsLoading,
  selectTotalFeedbackCount,
  selectTotalVotesCount,
  selectChannelFeatures,
  selectUpdateInProgress,
  selectChannelUpdateStatus,
  selectEmailTemplatesList,
  selectEmailTemplate,
  selectCreateTemplateStatus,
  selectDeleteTemplateIsLoading,
  selectEmailTemplatesListIsLoading,
  selectUpdateTemplateStatus,
  selectCreateTemplateEmailId,
  selectEmailTemplatesListTotal,
  selectActivateTemplateIsLoading,
  selectDeactivateTemplateIsLoading,
  selectSendTemplateStatus,
  selectEmailPreviewTemplate,
  selectSendTemplateResponse,
  selectUpdateFeaturesLoading,
  selectChannelFeaturesLoading,
  selectUserEmailPreferencesLoading,
  selectUserEmailPreferences,
  selectUserRoles,
  selectUserRolesLoading,
  selectUpdatedUserRolesLoading,
  selectBasicEmailTemplate,
  selectResetUserPasswordLoading,
  selectUserProfileDetails,
  selectUpdateEmailPreferencesLoading,
  selectUserProfileDetailsLoading,
  selectUserProfileDetailsUpdateInProgress,
  selectUserProfileDetailsUpdatedData,
  selectEmailTypesList,
  selectVirtualEventsReportId,
  selectVirtualEventsReportInProgress,
  selectVirtualEventsReportIsGenerating,
  selectVirtualEventsReportURL,
  selectVirtualEventsReportCancelStatus,
  selectVirtualEventsReportGenerationError,
  selectUpdateFeaturesStatus,
  selectUpdateFeaturesError,
  selectUpdateEmailPreferencesAccordionFlag,
  selectUserEmailPreferencesAccordionFlag,
  selectNurtureAnalytics,
  selectNurtureAnalyticsData,
  selectNurtureAnalyticsStats,
  selectNurtureAnalyticsLoading,
  selectNurtureAnalyticsError,
  selectNurtureAnalyticsUiState,
  selectNurtureAnalyticsDownloadInProgress,
  selectNurtureAnalyticsDownloadError
}
